export const mainPageStrings  = {
    title: 'Exoplanet Visualizer',
    subTitle: 'Discover the immensity of the universe'
}